import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useParcelsLoading = () => {
  const { parcelsLoading } = useSnapshot(skipTracingStore);

  return parcelsLoading;
};
